import { render, staticRenderFns } from "./LatestUserReview.vue?vue&type=template&id=20d99569&"
import script from "./LatestUserReview.vue?vue&type=script&lang=js&"
export * from "./LatestUserReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports